import { select, Store } from '@ngrx/store';
import { MonoTypeOperatorFunction } from 'rxjs';
import { filter, mapTo, switchMap, take } from 'rxjs/operators';

import { getIsUserStateInitialized } from '@features/auth/state/selectors';
import { IAppState } from '@shared/models';
import { selectRouterUrl } from '@shared/state/selectors';

export const waitUntilUserInitialized = <T>(store$: Store<IAppState>): MonoTypeOperatorFunction<T> =>
  switchMap((value: T) => store$.pipe(select(getIsUserStateInitialized), filter(Boolean), take(1), mapTo(value)));

export const waitUntilRouterInitialized = <T>(store$: Store<IAppState>): MonoTypeOperatorFunction<T> =>
  switchMap((value: T) => store$.pipe(select(selectRouterUrl), filter(Boolean), take(1), mapTo(value)));
